import { dollarsToCents } from '@common/paymentsUtils/currencyUtils';
import errorMessages from '@common/constants/errorMessages';
import { MAX_RENT_AMOUNT, MIN_RENT_AMOUNT } from '@rental-manager/constants/PaymentConstants';
import { logError } from '@zg-rentals/log-error';

// We limit the maximum number of options in the dropdown for the new rent amount effective date to 12.
export const RENT_AMOUNT_CHANGE_DROPDOWN_MAX = 12;

const isRentAmountValid = ({ newRentAmount, prevRentAmount }): string => {
  try {
    if (isNaN(newRentAmount)) {
      return errorMessages.MONTHLY_RENT_EMPTY;
    }

    if (newRentAmount === prevRentAmount) {
      return errorMessages.NEW_RENT_AMOUNT_MATCHES_PREVIOUS;
    }

    if (newRentAmount >= MIN_RENT_AMOUNT && newRentAmount <= MAX_RENT_AMOUNT) {
      return errorMessages.CLEAR_ERROR;
    }

    return errorMessages.MONTHLY_RENT_INVALID;
  } catch (err) {
    logError({
      error: err,
      context: `Rent amount validation error: ${err}`,
    });

    return errorMessages.MONTHLY_RENT_INVALID;
  }
};

export const validateAllInputs = (ctx) => {
  const { rentAmount } = ctx.state;
  const { prevRentAmount } = ctx.props;
  const newRentAmount = rentAmount.value;
  const errors: any = [];

  // validate and set all errors before returning
  const rentAmountError = isRentAmountValid({
    newRentAmount: Number(dollarsToCents(newRentAmount)),
    prevRentAmount: Number(prevRentAmount),
  });

  if (rentAmountError) {
    errors.push({ rentAmount: rentAmountError });
  }

  ctx.setState({
    rentAmount: { ...rentAmount, error: rentAmountError },
  });

  if (errors.length > 0) {
    ctx.props.trackValidationError({ errors });
    return false;
  }
  return true;
};
